module.exports = __webpack_public_path__ + "static/media/post-08.c86dfe50.jpg";